import { render, staticRenderFns } from "./Suministros.vue?vue&type=template&id=4edc1b31"
import script from "./Suministros.vue?vue&type=script&lang=js"
export * from "./Suministros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports